import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

import "nprogress/nprogress.css";

import './services/firebase';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
